import React, { useState, useEffect } from "react";
import { Modal, Button, Form,Alert } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_helpers";
import axios from "axios";
import { NODE_API_URL } from "../../../env_config";
import { useHistory } from "react-router-dom";
import { SwalSuccess ,SwalError } from "./";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Backdrop,CircularProgress,} from "@material-ui/core";
import {OverlayTrigger,Tooltip,Overlay} from "react-bootstrap";
import { FaExternalLinkAlt,FaInfoCircle} from "react-icons/fa";
const perfectScrollbarOptions = {
    wheelSpeed: 1,
    wheelPropagation: false,
};


export const HoldPopup = (props) => {
    // console.log(props.language)
    const [hidehold,setHideHold] = useState(false)
    const [showHold, setShowHold] = useState(false);
    const [showholdbtn, setShowHoldBtn] = useState(false);
    const [swalSuccessOpen,setSwalSuccessOpen] = useState(false)
    const [swalErrorOpen,setSwalErrorOpen] = useState(false)
    const [alertMessage,setAlertMessage] = useState()

    const [loading, setLoading] = React.useState(false);
    const[isSubmitting ,SetIsSubmitting] = useState(false)
    const [openLoader, setOpenLoader] = React.useState(false);
    const [ip,setIp] = React.useState()

    const enableLoading = () => {
        setLoading(true);
        setOpenLoader(true);
        SetIsSubmitting(true)
    };
    const disableLoading = () => {
        setLoading(false);
        setOpenLoader(false);
        SetIsSubmitting(false)
    };

    const history = useHistory()
    useEffect(() => {
        // console.log("Effect On Action")
        SetComment(null)
        setTime("Select Hours")
        setShowHoldBtn(false)
        props.diamondselected.map(value => {
            // console.log(value.can_hold,"EFFECR")
            if(value.can_hold === 1){
                setShowHoldBtn(true)
            }
        })
        axios({
            method: 'GET',
            // url: "http://ip-api.com/json/?fields=status,country,region,regionName,city,district,zip,isp,mobile,proxy,hosting,query",
            url:"https://api.ipify.org",
            // headers: { 
            //     'Access-Control-Allow-Origin': '*', 
            //     'Content-Type': 'application/json'
            //   },
            })
            .then(function (res) {
                // setIpdata({query:res.data})
                if(res && res.data){
                    setIp(res.data)                    
                }
            })
            .catch((res) => {
            });
    },[props.show])

    const closeModel = () => {
        props.onHide()
        setShowHold(false)
    }
    const closeSwal = (props) => {
        // props.onHide()
        setShowHold(true)
        setSwalSuccessOpen(false)
    }
    const swalSuccessOpenfn = (props) => {
        closeModel()
        setSwalSuccessOpen(true)
    }
    const swalErrorOpenfn = (props) => {
        closeModel()
        setSwalErrorOpen(true)
    }

    // console.log(hidehold,"hidehold")
    const HoldDiamonds = (diamonds,e) => {
        // console.log(time,"PRECIOUS")
        if(!time || time === "Select Hours"){
            e.preventDefault()
            return
        }
        // console.log(diamonds,"diamonds")
        const userData = JSON.parse(localStorage.getItem("userData"))
        let dianondinfo = diamonds.diamondselected.map(value => {
            return {
                diamond_id:value.id,
                diamond_type:value.diamond_type === "L"?value.diamond_type:"N",
                Certi_NO:value.Certi_NO
            }
        })
        const finalData = {
            "user_id":userData.CustomerId,
            "operation":"hold",
            "diamond_info":dianondinfo,
            customer_comment:comment,
            hold_time:time,
            "ip":ip
        }
        // console.log(finalData,"finalData")
        enableLoading()
        axios({
            method: "POST",
            url: `${NODE_API_URL}/TESTMODE/HoldorBuyDiamonds`,
            headers: { "Content-Type": "application/json" },
            data: finalData,
        }).then(res => {
            disableLoading()
            if (res.data.success === false){
                swalErrorOpenfn()
                setAlertMessage(res.data.error)
            }
            if(res && res.data && res.data.success){
                // console.log(res.data)
                // alert(JSON.stringify(res.data.data))
                setAlertMessage(res.data.data[0].status)
                for(let i = 0 ; i < res.data.data.length;i++){
                    if(res.data.data[i].issuccess === true){
                        swalSuccessOpenfn()
                        reDirectToConfirm()
                    } else if (res.data.data[i].issuccess === false || res.data.data[i].ssuccess===false){
                        swalErrorOpenfn()
                    }
                }
                // setTime(null)
                // SetComment(null)
            }
            else{
                disableLoading()
                setAlertMessage(res.data.error)
                swalErrorOpenfn()
                // alert(JSON.stringify(res.data.error))
            }
        }).catch(err => {
            disableLoading()
        })
    }

    const reDirectToConfirm = () => {
        history.push({
            pathname: `/hold-diamonds`
        })
    }
    const [comment,SetComment] = useState(null)
    const [time,setTime] = useState("Select Hours")
    // console.log(time,"time")
    function numberWithCommas(x) {
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.onHide}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.language.HOLD_DIAMOND_POPUP_CONFIRM_HOLD}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            {/* <Alert variant="danger">
                                {props.language.HOLD_DIAMOND_POPUP_INR_MSG}
                            </Alert> */}
                        </div>
                        <div className="col-12 d-flex justify-content-between mb-3">
                            <span>{props.language.CONFIRM_GOODS_POPUP_TOTAL_DIAMONDS} : {props.diamondselected.length}</span>
                            <div>
                                {((props.diamondselected.length) - props.diamondcount ) == 0 ||  props.diamondcount == 0 ? "":
                                 <div className="d-flex font-weight-bold">
                                    <div className="text-success mr-2">{props.diamondcount} Diamonds are valid</div> 
                                    <div className="text-danger">{((props.diamondselected.length) - props.diamondcount )} Diamonds are not available for hold</div>
                                </div>}
                            </div>
                        </div>
                        < div className="col-12">
                            <PerfectScrollbar
                                options={perfectScrollbarOptions}
                                className="scroll border-bottom"
                                style={{ maxHeight: "322px", position: "relative" }}
                            >
                                <table className="table border-bottom">
                                    <thead>
                                        <tr className="bg-gray-100 sticky-top">
                                            <th align="center" className="text-center py-3"><p className="mb-2">{props.language.CONFIRM_GOODS_POPUP_DIAMOND_DETAILS}</p></th>
                                            <th className="text-center py-3"> {props.language.CONFIRM_GOODS_POPUP_DIAMOND_LOCATION} </th>
                                            <th align="center" className="text-center py-3"><p className="mb-2">{props.language.HOLD_DIAMOND_POPUP_DISCOUNT}</p ></th>
                                            <th align="center" className="text-right py-3">
                                                {props.language.CONFIRM_GOODS_POPUP_OURPRICEUSD} <br />
                                                USD/CT
                                            </th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.diamondselected.map((value,index) => (
                                            <tr className={`position-relative ${value.can_hold !== 1 ? "cursor-na" : ""}`}>
                                        
                                            <td>
                                                { value.can_hold === 0 ?  <span className="CanNotHold"> DIAMOND NOT AVAILABLE FOR HOLD</span> : ""}
                                                {/* { value.can_hold !== 1  ? 
                                                    value.country === "INDIA" && value.can_hold === 0 ? <span className="CanNotHold"> DIAMOND NOT AVAILABLE FOR HOLD</span> : "" : ""} */}

                                                {/* {value.country !== "INDIA" ?  <span  className="CanNotHold"> Unfortunately, Diamond location outside India cant be ordered</span> :""}
                                                {value.can_hold === 1 && value.country === "INDIA" ? "":  <span  className="CanNotHold"> DIAMOND NOT AVAILABLE FOR HOLD</span> } */}
                                                {/* {value.can_hold === 1 ? "":  <span className="CanNotHold"> DIAMOND NOT AVAILABLE FOR HOLD</span> } */}
                                                <div className={`row ${value.can_hold !== 1 ? "CanNotHoldDiv" : "" }`}>
                                                    <div className="col-2 text-center p-0">
                                                        {value.aws_image ? (
                                                            <img
                                                                className="img-fluid mr-2" alt={value.C_Shape} src={value.aws_image} width="50px"
                                                            />
                                                        ) : (
                                                            <img
                                                                className="img-fluid mr-2"
                                                                alt={value.C_Shape}
                                                                src={toAbsoluteUrl(`/media/shape/${value.C_Shape.toLowerCase()}-no.png`)}
                                                                width="50px"
                                                                style={{backgroundColor:"#f4f4f4"}}
                                                            />
                                                        )}
                                                    </div>
                                                    <div className="col-10 pl-2 p-0">
                                                        <div className="mb-1">
                                                            <span
                                                                className={`${
                                                                    value.diamond_type === "N" || value.diamond_type === "W"
                                                                        ? value.C_Color ===
                                                                        "fancy"
                                                                            ? "F"
                                                                            : "W"
                                                                        : value.C_Color ===
                                                                        "fancy"
                                                                        ? "LF"
                                                                        : "L"
                                                                }_diamond mr-3 small`}
                                                            >
                                                                {value.diamond_type === "N" || value.diamond_type === "W"
                                                                    ? value.C_Color ===
                                                                    "fancy"
                                                                        ? "F"
                                                                        : "W"
                                                                    : value.C_Color ===
                                                                    "fancy"
                                                                    ? "LF"
                                                                    : "L"}
                                                            </span>
                                                            <span className="text-primary small">
                                                                {value.Lab}-
                                                                {value.Certi_NO}
                                                            </span>
                                                            <span className="small ml-2">
                                                                {value.diamond_type === "N" || value.diamond_type === "W" ? "N" : "L"}-{value.id}
                                                            </span>
                                                        </div>

                                                        <span className="text-dark font-weight-bold d-block">
                                                            {value.C_Shape}{" "}
                                                            {value.C_Weight.toFixed(
                                                                2
                                                            )}{" "}
                                                            {value.C_Color ===
                                                            "fancy" ? (
                                                                <>
                                                                    {
                                                                        value.f_intensity
                                                                    }{" "}
                                                                    {
                                                                        value.f_overtone
                                                                    }{" "}
                                                                    {
                                                                        value.f_color
                                                                    }{" "}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {
                                                                        value.C_Color
                                                                    }{" "}
                                                                </>
                                                            )}
                                                            {value.C_Clarity}{" "}
                                                            {value.C_Cut}{" "}
                                                            {value.C_Polish}{" "}
                                                            {value.C_Symmetry}{" "}
                                                            {
                                                                value.C_Fluorescence
                                                            }{" "}
                                                        </span>
                                                    
                                                    </div>
                                                </div>
                                            </td>
                                            <td className={`text-center ${value.can_hold !== 1? "CanNotHoldDiv" : "" }`}>
                                            {value.country} <br />
                                            {/* {value.shipping_days} days */}
                                            </td>
                                            <td className={`text-center text-danger ${value.can_hold !== 1 ? "CanNotHoldDiv" : "" }`}>
                                            {value.discount_main?value.discount_main.includes('-')?
                                                        <div className="text-danger">{value.discount_main}% Off</div>:
                                                        <div className="text-success">{value.discount_main}% PR</div>
                                                        :<div className="text-success">00.00% Off</div>}
                                            </td>
                                            <td className={`text-right text-primary ${value.can_hold !== 1 ? "CanNotHoldDiv" : "" }`}>
                                                ${numberWithCommas(value.OurPrice)} 
                                                {value.show_supplier === 1?<OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip">
                                                           Supplier Price: ${value["SupplierRate"]}<br/>
                                                           Our Charges: ${(Math.round(value["newcharge"] * 100)/100).toFixed(2)} 
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span className="ml-2 text-hover-primary cursor-pointer"><FaInfoCircle /></span>
                                                </OverlayTrigger>:""}<br/>
                                                <span className="text-muted small">USD/CT {numberWithCommas(value.OurRate)}</span>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </PerfectScrollbar>
                            <div className="text-primary font-weight-bold mt-4 font-italic" >{props.diamondselected.length > 4 ? "Scroll for explore all diamonds":""}</div>
                            <div className="row mt-5">
                                <div className="col-md-5">
                                    <Form.Group controlId="exampleForm.ControlSelect1">
                                        <Form.Label>{props.language.HOLD_DIAMOND_POPUP_TIMEPERIOD}:</Form.Label>
                                        <Form.Control as="select" onChange={(e) => setTime(e.target.value)}>
                                            <option>Select Hours</option>
                                            <option value="12">12 Hours</option>
                                            <option value="24">24 Hours</option>
                                            <option value="48">48 Hours</option>
                                        </Form.Control>
                                        {time === "Select Hours" ? <span className="text-danger mt-2 font-weight-bold"> Please Select Hours</span> : "" }
                                    </Form.Group>
                                </div>
                                <div className="col-md-7">
                                    <div className="row">
                                    <div className="col-12 font-size-h6 text-right">
                                    USD/CT {props.language.CONFIRM_GOODS_POPUP_PRICE} : ${numberWithCommas(props.totalinrcar)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bolder">
                                    {props.language.SEARCHGRID_TOTAL} USD : ${numberWithCommas(props.totalourprice)}
                                </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <Form.Group controlId="Notes">
                                        <Form.Label>
                                            {props.language.CONFIRM_GOODS_POPUP_NOTES}:
                                        </Form.Label>
                                        <Form.Control as="textarea" rows="3" onChange={(e) => SetComment(e.target.value)} maxLength={256} placeholder="Please enter your notes if any"/>
                                    </Form.Group>
                                    <span className="p-2">255 Characters Remaining</span>
                                </div>
                            </div>
                            {/* <pre>{JSON.stringify(props)}</pre> */}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-between py-3">
                    {props.conversionrate !== 1 ?<span className="font-weight-bold"> All purchase are under USD</span>:""}
                    <div>
                        <Button variant="secondary" className="mr-2 font-weight-bold" onClick={props.onHide}>
                            {props.language.CONFIRM_GOODS_POPUP_CLOSE}
                        </Button>
                        {showholdbtn?<Button variant="primary" className="px-8 font-weight-bold" disabled={isSubmitting} onClick={(e) => HoldDiamonds(props,e)}>
                            {props.language.HOLD_DIAMOND_POPUP_CONFIRM_HOLD_BTN}
                            {loading && <span className="ml-1 spinner spinner-white"></span>}
                            <Backdrop
                                sx={{ color: '#002173', zIndex: (theme) => theme.zIndex.drawer + 5 }}
                                open={openLoader}
                                // onClick={handleCloseLoader}
                            >
                                <CircularProgress color="secondary" />
                            </Backdrop>
                        </Button>:""}
                        {/* {props.can_hold === 1 ? <Button variant="primary">Hold Diamond</Button>  : ""} */}
                    </div>
                </Modal.Footer>
            </Modal>
            <SwalSuccess show={swalSuccessOpen} message={alertMessage} onClose={() => setSwalSuccessOpen(false)} responseOnOk={reDirectToConfirm}/> 
            <SwalError show={swalErrorOpen} message={alertMessage} onClose={() => setSwalErrorOpen(false)} closeBtn={true}/> 
        </div>
    );
};
